// Addresses of TrustClap's public surfaces (dev plan, "Public surfaces").
// A <script> or <img> on someone else's website cannot send X-Site-Slug, and in development
// a localhost gateway would resolve it to the default site. So in development every embed
// and public image goes through this dev server's /pb-api proxy (vue.config.js), which
// forwards to the gateway named by VUE_APP_API_BASE_URL and adds the header. In production
// the API host itself identifies the site.
import config from './config';

export function publicApiBase() {
  if (process.env.NODE_ENV === 'development') return window.location.origin + '/pb-api';
  return config.api.baseURL;
}

export function appOrigin() {
  return window.location.origin;
}

export function imageUrl(key) {
  return key ? publicApiBase() + '/apps/praiseboard/public/images/' + encodeURIComponent(key) : '';
}

export function embedScriptUrl(widget, preview) {
  const base = publicApiBase() + '/apps/praiseboard/embed/' + encodeURIComponent(widget.public_key) + '.js';
  return preview ? base + '?preview=' + encodeURIComponent(preview) : base;
}

export function collectUrl(form) {
  return form && form.public_key ? appOrigin() + '/c/' + form.public_key : '';
}

export function wallUrl(brand) {
  return brand && brand.slug ? appOrigin() + '/w/' + brand.slug : '';
}

function escapeHtml(value) {
  return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// The copy-and-paste install code. The link inside the box stays visible if the script
// cannot run, so a blocked or failed widget still sends visitors to the hosted wall.
export function embedSnippet(widget, brand) {
  if (!widget || !widget.public_key) return '';
  const name = brand && brand.name ? brand.name : 'us';
  return '<div data-trustclap-widget="' + widget.public_key + '"><a href="' + escapeHtml(wallUrl(brand)) + '">'
    + 'Read what customers say about ' + escapeHtml(name) + '</a></div>\n'
    + '<script async src="' + escapeHtml(embedScriptUrl(widget)) + '"></script>';
}
